import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-p-group-multiselect',
  template: require('./p-group-multiselect.component.html'),
  styles: [require('./p-group-multiselect.component.sass')]
})
export class PGroupMultiselectComponent implements OnInit {

  public selectedOptions: Array<SelectItem> = new Array<SelectItem>();
  public selectedItemsLabel = 'Choose';
  @Input() options: Array<SelectItem>;
  @Output() selectedChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    this.options.forEach(option => {
      this.updateSelectedOptions(option);
    })
  }

  public onChangeMultiSelect($event) {
    if ($event.itemValue) {
      // this is when a single multi select option is clicked
      this.handleMultiSelectOptionClicked($event);
    } else {
      // this is when header check box is clicked
      this.handleMultiSelectHeaderClicked($event);
    }
  }

  private handleMultiSelectOptionClicked(event) {
    let elementChecked = false;
    event.value.forEach(element => {
      if (element.label === event.itemValue.label) {
        elementChecked = true;
      }
    });
    if (elementChecked) {
      // this is when element is checked
      this.options.forEach((option) => {
        if (option.value.label === event.itemValue.label) {
          option.value.selectedChildOptions = [];
          event.itemValue.childOptions.forEach(element => {
            option.value.selectedChildOptions[element.id] = true;
          });
        }
      });
    } else {
      // this is when element is unchecked
      this.options.forEach((option) => {
        if (option.value.label === event.itemValue.label) {
          option.value.selectedChildOptions = {};
        }
      });
    }

    this.selectedChange.emit(this.options)
  }

  private handleMultiSelectHeaderClicked(event) {
    if (event.value.length === this.options.length) {
      this.options.forEach((option) => {
          option.value.selectedChildOptions = [];
          option.value.childOptions.forEach(element => {
            option.value.selectedChildOptions[element.id] = true;
          });
      });
    } else {
      this.options.forEach((option) => {
        option.value.selectedChildOptions = {};
      });
    }
  }


  updateSelectedOptions = (option) => {
    const selectedOptions = Object.keys(option.value.selectedChildOptions).filter(key => !!option.value.selectedChildOptions[key])
    // $event is true or false depending on whether its checked or unchecked.
    if (option.value.childOptions.length !== selectedOptions.length) {
       this.selectedOptions = this.selectedOptions.filter((selectedOption) => selectedOption.label !== option.value.label);
      } else {
        this.selectedOptions = [...this.selectedOptions];
        this.selectedOptions.push(option.value);
      }
  }

  public onChangeChildOptionCheckbox(option) {
      this.updateSelectedOptions(option);
      this.selectedChange.emit(this.options)
  }

  public onClickChildOptionCheckbox(event) {
    event.stopPropagation();
  }

  public onClickChildOptionContainer(event) {
    event.stopPropagation();
  }

}
